import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    const path = location.pathname;

    let page_type = "other";
    let business_slug = null;

    // Map your pages
    if (path === "/") page_type = "home";
    else if (path === "/login") page_type = "login";
    else if (path === "/signup") page_type = "signup";
    else if (path === "/user") page_type = "user";
    else if (path === "/analytics") page_type = "analytics";
    else if (path === "/orders") page_type = "orders";
    else if (path === "/templates") page_type = "templates";

    // MENU PAGE (dynamic)
    else if (path.startsWith("/menu/")) {
      page_type = "menu";
      business_slug = path.split("/menu/")[1];
    }

    window.gtag("config", "G-JB13HSTHXW", {
      page_path: path,
      page_title: document.title,
      page_type,
      business_slug,
    });

  }, [location]);
};

export default usePageTracking;